import React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {GALinkStatus} from '../../../../../../../../../util/uiconstants';
import {currentResource} from '../../../../../../../../../util/utils';

import getTitle from './getTitle';

import {sendLinkRequest} from '../../../../../../../../../actions/GroupAudit/GroupComponents';

import InvalidNoPoC from './InvalidNoPoC';
import StatusDot from './StatusDot';
import StatusLink from './StatusLink';
import StyledRejected from './StyledRejected';
import StyledLinkRequestStatus from './StyledLinkRequestStatus';

export const LinkRequest = (item) => {
	const labels = currentResource.groupStructure;
	const engagementId = useSelector(({engagementId}) => engagementId);
	const dispatch = useDispatch();

	const handleSendComponent = (item) => {
		const payload = {
			GroupComponents: [
				{
					GroupComponentId: item.gaComponentId,
					ConcurrencyToken: item.concurrencyToken
				}
			]
		};

		item.setIsLoading(true);
		dispatch(sendLinkRequest(engagementId, payload)).finally(() => item.setIsLoading(false));
	};

	const renderStatusDot = (title = null) => (
		<StatusDot title={title || getTitle(item, labels)} linkRequestId={item?.linkRequest} />
	);

	const renderLink = (tooltipText, altProps = null) => {
		const props = {
			item,
			labels,
			onClick: handleSendComponent,
			tooltipText
		};

		if (altProps) props.altProps = altProps;

		return <StatusLink {...props} />;
	};

	const renderRejected = (tooltipText) => {
		return (
			<StyledRejected>
				{renderStatusDot()}
				{renderLink(tooltipText)}
			</StyledRejected>
		);
	};

	const renderEditComponent = () => {
		const props = {item, renderButton: renderLink};

		return <InvalidNoPoC {...props} />;
	};

	const renderDefault = () => renderStatusDot('-');

	const renderSwitch = () => {
		switch (item.linkRequest) {
			case GALinkStatus.Pending:
			case GALinkStatus.Accepted:
			case GALinkStatus.Unlinked:
			case GALinkStatus.Sent:
			case GALinkStatus.ComponentNotUsingCanvas:
				return renderStatusDot();
			case GALinkStatus.NoPointOfContact:
			case GALinkStatus.InvalidPointOfContact:
				return renderEditComponent();
			case GALinkStatus.NotSent:
				// #1114867
				if (item.pocGui === null || item.pocText === null) return renderEditComponent();

				return renderLink(currentResource.groupStructure.manageGroupPermission);
			case GALinkStatus.Rejected:
				// #1114867
				if (item.pocGui === null || item.pocText === null) return renderEditComponent();

				return renderRejected(currentResource.groupStructure.manageGroupPermission);
			default:
				return renderDefault();
		}
	};

	return <StyledLinkRequestStatus className="lr-status">{renderSwitch()}</StyledLinkRequestStatus>;
};

